import React from 'react';
import styled from 'styled-components';

import VisibilityAnimation from './VisibilityAnimation';

const Content = styled(props => <VisibilityAnimation visible duration="0.4s" show="fade-in" hide="fade-out" {...props} />)`
  padding: 0 1.875rem 1.875rem 1.875rem;

  @media (max-width: 50rem) {
    padding: 0 1.25rem 1.25rem 1.25rem;
  }
`;

export default Content;
